/* SortOptionsComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
// const _ = require("lodash");
const Renderer = require("./SortOptionsRenderer");
// const Steve = require("@gluenetworks/steve_core").getInstance();

class SortOptionsComponent extends EventEmitter {
    constructor(logger, slickData, sortData) {
        super();
        // console.log(sortData);
        this._sortData = sortData || {};
        this._slickData = slickData;
        this._dataForSlick = this.getDataForSlick(this._slickData.getItems());
        this._titleText = "Sort Order";
        this._logger = logger;
        // this._darkTheme = _.get(options, 'darkTheme', true);
        this._darkTheme = true;
        // this._workType = _.get(options, "workType", null);
        // this._userSession = Steve.di.getRegistered("$teve.userSession").registeredObj;
        this._fields = undefined;
        this._updatedSortData = Object.assign({}, this._sortData);
        this._renderer = new Renderer(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    get darkTheme() {
        return this._darkTheme;
    }

    get workType() {
        return this._workType;
    }

    get userSession() {
        return this._userSession;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._darkTheme = undefined;
                this._sortData = undefined;
                // this._workType = undefined;
                this._titleText = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "SortOptionsComponent.shutdown() error");
            }
        );
    }

    save(updatedSort) {
        this._context.resolve(updatedSort);
    }

    cancel(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/
    getFieldValues() {
        const items = this._slickData.getItems();
        const fields = items.map((item) => {
            // console.log(item);
            return item.field;
        });
        this._fields = fields;
        // console.log(this._fields);
        return [...new Set(fields)];
    }

    getDataForSlick(data) {
        const dataItems = data
            .filter((item) => {
                if (item.sortType) {
                    return true;
                }
                return false;
            })
            .map((item) => {
                let _item = Object.assign({}, item);
                switch (item.dataType) {
                    case "number":
                        _item.sortType = _item.sortType === "desc" ? "Highest first" : "Lowest first";
                        break;
                    case "unixTime":
                        _item.sortType = _item.sortType === "desc" ? "Newest first" : "Oldest first";
                        break;
                    default:
                        _item.sortType = _item.sortType === "desc" ? "Z to A" : "A to Z";
                }
                _item.field = _item.field.replace(/>/g, " > ");
                return _item;
            });

        return dataItems.sort((a, b) => {
            return a.sortOrder - b.sortOrder;
        });
    }

    getUpdatedSlickData(updatedSortOrder) {
        // reset sortOredr for all
        // this._slickData.getItems().forEach(item => {
        //     item.sortOrder = 0;
        // });

        // updatedSortOrder.forEach(item => {
        //     this._slickData.getItemById(item.id).sortOrder = item.sortOrder;
        // });
        for (let i = 0; i < updatedSortOrder.length; i++) {
            this._slickData.getItemById(updatedSortOrder[i].id).sortOrder = i + 1; // 0 implies no sorting
        }
        return this._slickData;
    }
    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SortOptionsComponent;
